import { render, staticRenderFns } from "./ListImageSwipeWebpartTest.vue?vue&type=template&id=5237d484"
import script from "./ListImageSwipeWebpartTest.vue?vue&type=script&lang=js"
export * from "./ListImageSwipeWebpartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports